import React from 'react';
import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import PostLink from '../../../../common/components/link/post-link';
import { connect } from '../../../../common/components/runtime-context';
import withTranslate from '../../../../common/hoc/with-translate';
import { getCreatePostUrl } from '../../../../common/services/get-post-url';
import { getTopology } from '../../../../common/store/topology/topology-selectors';
import { ROUTE_CREATE_POST } from '../../../../post-page/constants/routes';
import { classes } from './create-post-button-desktop.st.css';

const CreatePostButtonDesktop = ({ t, createPostUrl }) => (
  <TextButton
    as={PostLink}
    postLink={createPostUrl}
    postPath={ROUTE_CREATE_POST}
    className={classes.root}
    priority={TextButtonPriority.primary}
    data-hook="create-post-button"
  >
    {t('create-post-button.label')}
  </TextButton>
);

CreatePostButtonDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  createPostUrl: PropTypes.string.isRequired,
};

const mapRuntimeToProps = (state) => ({
  createPostUrl: getCreatePostUrl(getTopology(state)),
});

export default flowRight(withTranslate, connect(mapRuntimeToProps))(CreatePostButtonDesktop);
